    <template>
    <div class="container-fluid">
        <section class="wallet-shell">
            <div class="wallet-hero">
                <div class="wallet-hero-copy">
                    <p class="hero-eyebrow">PlePower Wallet</p>
                    <h1>Wallet history and transfer activity</h1>
                    <p class="hero-text">Review credits, debits and recent wallet activity in one clean place.</p>
                </div>
                <div class="wallet-summary-grid">
                    <div class="summary-card">
                        <span class="summary-label">Total Transactions</span>
                        <strong>{{ contractQty || 0 }}</strong>
                        <span class="summary-note">Wallet records available</span>
                    </div>
                    <div class="summary-card summary-card-soft">
                        <span class="summary-label">Account Holder</span>
                        <strong>{{ firstname }} {{ lastname }}</strong>
                        <span class="summary-note">{{ account_number || 'Transfer account pending' }}</span>
                    </div>
                </div>
            </div>

            <div class="wallet-table-card">
                <div class="contract-header">
                    <div>
                        Wallet Transactions
                        <span class="wallet-count">{{ contractQty || 0 }}</span>
                    </div>
                    <p class="wallet-table-note">Latest credits and debits on your wallet</p>
                </div>

                <div class="table table-responsive table-sm wallet-table-wrap">
                    <v-data-table
                        :headers="header"
                        :items="desserts"
                        dense
                        class="wallet-data-table table-responsive"
                    >
                        <template v-slot:item.contract_number="{ item }">
                            <div class="a-text">{{ item.contract_number }}</div>
                        </template>
                        <template v-slot:item.contracttitle="{ item }">
                            <div class="a-text">{{ item.contracttitle }}</div>
                        </template>
                        <template v-slot:item.beneficiary="{ item }">
                            <div class="a-text">{{ item.beneficiary }}</div>
                        </template>
                        <template v-slot:item.amount="{ item }">
                            <div class="a-text">&#8358;{{ item.amount }}</div>
                        </template>
                        <template v-slot:item.payment_mode="{ item }">
                            <div class="a-text">{{ item.payment_mode }}</div>
                        </template>
                        <template v-slot:item.payment_date="{ item }">
                            <div class="a-text">{{ item.payment_date }}</div>
                        </template>
                        <template v-slot:no-data>
                            <div class="wallet-empty-state">
                                <i class="fa fa-wallet"></i>
                                <h4>No wallet transactions yet</h4>
                                <p>Your wallet credits and debits will appear here once activity starts.</p>
                            </div>
                        </template>
                    </v-data-table>
                </div>
            </div>
        </section>
        
        <p>&nbsp;</p>
        <page-loader :is-loading="isLoading"></page-loader>
    </div>
    </template>
    
      
    <script>
    //import 'quill/dist/quill.snow.css';
    // import {
    //     quillEditor
    // } from 'vue-quill-editor';
    
   // import swal from 'sweetalert2';
    import PageLoader from '../components/PageLoader.vue'
    export default {
    
        name: "TransactionPage",
        components: {
            //quillEditor,
            PageLoader
        },
    
        data() {
            return {
    
                isLoading: false,
                isRightImage: false,
                isLeftImage: false,
                isBackImage: false,
                user_id: '',
                firstname: '',
                lastname: '',
                bank_name: '',
                account_name: '',
                account_number: '',
    
                loading: false,
                loading1: false,
                loading2: false,
                loading3: false,
                role_type: '',
                contract_title: '',
                transaction_type: '',
                delivery_type: '',
                delivery_location: '',
                delivery_time: '',
                contract_amount: '',
                transaction_fee: '',
                whois_paying: '',
                contract_rebate: '',
                product_description: '',
                accept_terms: '',
    
                products: [],
                subcategorys: [],
                selectedFile: '',
                selectedFile1: '',
                selectedFile2: '',
                selectedFile3: '',
                addProduct: false,
                viewProduct: true,
                editorOptions: {
                    placeholder: 'Write something...',
                },
    
                isVariations: false,
                productid: '',
                variations: '',
                vprice: '',
                is_fees_status: false,
                is_submit: false,
                is_submit1: false,
                is_submit2: false,
                is_submit3: false,
                img_url: process.env.VUE_APP_IMAGE_URL,
                header: [
                   
                    // {
                    //     value: 'contracttitle',
                    //     text: 'Transaction title'
                    // },

                    {
                        value: 'payment_reference',
                        text: 'Transaction reference'
                    },
                    {
                        value: 'payment_mode',
                        text: 'Transaction method'
                    },
                    {
                        value: 'credit',
                        text: 'Credit'
                    },
                    {
                        value: 'debit',
                        text: 'Debit'
                    },
                    {
                        value: 'payment_date',
                        text: 'Transaction date'
                    },

                ],
    
                desserts: [],
                user_role: '',
                product_id: '',
                userid: '',
                contractQty: '',
                deliveryType: [{
                        text: 'Same day delivery (14 hours max)',
                        value: 'Same day delivery (14 hours max)'
                    },
                    {
                        text: 'Interstate',
                        value: 'Interstate'
                    },
                ],
    
                transactionType: [{
                        text: 'Physical Product',
                        value: 'Physical Product'
                    },
                    {
                        text: 'Services',
                        value: 'Services'
                    },
                    {
                        text: 'Digital Product',
                        value: 'Digital Product'
                    },
                    {
                        text: 'Mutual Contract',
                        value: 'Mutual Contract'
                    },
                ],
                roleType: [{
                        text: 'Seller',
                        value: '1'
                    },
                    {
                        text: 'Buyer',
                        value: '2'
                    },
                ],
    
                contractsData: [],
                isPeriod: false,
                delivery_period: '',
                payment_status: '',
                is_escrow_charge: false,
    
            };
        },
    
        beforeMount() {
    
        },
    
        mounted() {
    
            this.firstname = localStorage.getItem("firstname");
            this.lastname = localStorage.getItem("lastname");
            this.phone_number = localStorage.getItem("phone");
            this.email_address = localStorage.getItem("email");
            this.user_id = localStorage.getItem("userid");
    
            this.bank_name = localStorage.getItem("bank_name");
            this.account_name = localStorage.getItem("account_name");
            this.account_number = localStorage.getItem("account_number");
            this.user_role = localStorage.getItem("user_role");
    
            this.fetchAllPaymentByUser(this.user_id)
    
            // if (this.user_role == 1) {
            //     this.fetchProducts()
               
            // } else if (this.user_role == 3) {
            //     this.fetchMyProducts(this.user_id)
            // }
        },
    
        created() {
    
        },
    
        computed: {
    
            isProductEnabled() {
                return (
                    this.role_type === '' ||
                    this.contract_title === '' ||
                    this.delivery_type === '' ||
                    this.delivery_time === '' ||
                    this.contract_amount === '' ||
                    this.product_description === '' ||
                    this.whois_paying === '' ||
                    this.accept_terms === '' ||
                    this.delivery_location === ''
                );
            },
    
            indexSn() {
                return this.desserts.map((d, index) => ({
                    ...d,
                    sn: index + 1
                }))
            },
    
        },
    
        methods: {
            fee_handling(){
                this.is_escrow_charge = true
            },
            processPayment(contract_id){
                this.$router.push('/checkout/summary/'+contract_id)
            },
          
            addVariations(productid) {
                this.productid = productid
                this.isVariations = true
            },
    
          
            formatToCurrency(value) {
              return value.toLocaleString('en-NG', { minimumFractionDigits: 2 })
            },
    
            copyToClipboard(link) {
               // var copyText = document.getElementById("myInput");
                navigator.clipboard.writeText(link).then(function() {
                    alert("Contract link copied to clipboard!");
                }).catch(function(err) {
                    console.error('Failed to copy: ', err);
                });
            },
    
            async fetchAllPaymentByUser(userid) {
                try {

                    this.isLoading = true
                    this.desserts = []
                    const response = await this.$http.post('/fetch-wallets-byuser', {
                        user_id: userid
                    })
                    this.isLoading = false
                    
                    this.contractsData = response.data.wallet_list
                    this.contractQty = this.contractsData.length
                    this.contractsData.forEach(el => {
                        this.desserts.push({
                            contracttitle: el.contract_title,
                            payment_reference: el.payment_reference,
                            payment_mode: el.payment_method,
                            credit: el.credit.toLocaleString('en-NG', {
                                minimumIntegerDigits: 2
                            }),
                            debit: el.debit.toLocaleString('en-NG', {
                                minimumIntegerDigits: 2
                            }),
                            payment_date: new Date(el.created_at).toUTCString(),
        
                        })
                    });
    
                } catch (err) {
                    console.log(err);
                }
            },
       
        }
    
    }
    </script>
      
    <style lang="scss" scoped>
    @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;700&display=swap');
    
    .container-fluid {
        min-height: 100vh;
        padding: 1.25rem 2rem 2rem;
        background:
            radial-gradient(circle at top left, rgba(36, 86, 43, 0.12), transparent 28%),
            linear-gradient(180deg, #f4f8f5 0%, #eef3ef 100%);
    }
    .wallet-shell {
        max-width: 1180px;
        margin: 0 auto;
    }
    .wallet-hero {
        display: grid;
        grid-template-columns: 1.35fr 1fr;
        gap: 1.2rem;
        align-items: stretch;
        margin-bottom: 1.25rem;
    }
    .wallet-hero-copy,
    .wallet-summary-grid {
        border-radius: 24px;
        box-shadow: 0 20px 45px rgba(11, 39, 24, 0.08);
    }
    .wallet-hero-copy {
        padding: 2rem;
        color: #fff;
        background: linear-gradient(135deg, #16372d 0%, #24562b 58%, #3b7a4d 100%);
    }
    .hero-eyebrow {
        margin: 0 0 0.6rem;
        font-size: 11px;
        font-weight: 700;
        letter-spacing: 0.12em;
        text-transform: uppercase;
        color: rgba(255, 255, 255, 0.72);
        font-family: Poppins;
    }
    .wallet-hero-copy h1 {
        margin: 0;
        font-size: 32px;
        line-height: 1.15;
        font-weight: 700;
        font-family: Poppins;
    }
    .hero-text {
        margin: 0.9rem 0 0;
        max-width: 520px;
        font-size: 14px;
        line-height: 1.7;
        color: rgba(255, 255, 255, 0.84);
        font-family: Poppins;
    }
    .wallet-summary-grid {
        display: grid;
        grid-template-columns: repeat(2, minmax(0, 1fr));
        gap: 1rem;
        padding: 1rem;
        background: rgba(255, 255, 255, 0.72);
        backdrop-filter: blur(10px);
    }
    .summary-card {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        min-height: 172px;
        padding: 1.25rem;
        border-radius: 20px;
        background: linear-gradient(180deg, #ffffff 0%, #f4f8f5 100%);
        border: 1px solid rgba(22, 55, 45, 0.08);
        font-family: Poppins;
    }
    .summary-card-soft {
        background: linear-gradient(180deg, #f5fbf6 0%, #edf7ef 100%);
    }
    .summary-label {
        font-size: 11px;
        font-weight: 700;
        letter-spacing: 0.1em;
        text-transform: uppercase;
        color: #6f8579;
    }
    .summary-card strong {
        margin: 0.85rem 0 0.55rem;
        font-size: 28px;
        line-height: 1.2;
        color: #16372d;
        word-break: break-word;
    }
    .summary-note {
        font-size: 12px;
        line-height: 1.6;
        color: #65766e;
    }
    .wallet-table-card {
        padding: 1.2rem;
        border-radius: 24px;
        background: #ffffff;
        border: 1px solid rgba(22, 55, 45, 0.07);
        box-shadow: 0 20px 45px rgba(11, 39, 24, 0.07);
    }
    .copy-refid{
        cursor: pointer;
        font-size: 16px;
      }
    .a-text {
        font-size: 12px;
        font-family: Poppins;
    }
    .process-payment{
        cursor:pointer;
    
    }
    label {
        font-size: 12px;
        font-family: Poppins;
        font-weight: normal;
    }
    
    .inputs {
        margin-top: 20px;
        border-radius: 3px;
        font-size: 12px;
    }
    
    .price-fee {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
    
        div {
            margin: 4px;
            width: 100%;
    
        }
    }
    
    .adjust-fee-input {
        // width: 100px;
        text-align: center;
    }
    
    .whopays-fee-input {
        //width: 100% !important;
    }
    
    .shop-detail {
        font-size: 12px;
        font-family: Poppins;
    }
    
    .btn-danger {
        text-transform: uppercase;
        font-size: 13px;
        font-family: Poppins;
        background: #2979FF;
        border: 0px;
        height: 45px;
    }
    
    .contract-header {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        gap: 1rem;
        background: linear-gradient(135deg, #16372d 0%, #24562b 100%);
        color: #fff;
        border-radius: 20px;
        padding: 1rem 1.2rem;
        font-size: 14px;
        font-weight: 700;
        font-family: Poppins;
        margin-bottom: 0.9rem;
    }
    .wallet-count {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        min-width: 32px;
        height: 32px;
        padding: 0 0.7rem;
        margin-left: 0.55rem;
        border-radius: 999px;
        background: rgba(255, 255, 255, 0.16);
        font-size: 12px;
        font-weight: 700;
    }
    .wallet-table-note {
        margin: 0;
        font-size: 12px;
        font-weight: 500;
        color: rgba(255, 255, 255, 0.8);
    }
    .wallet-table-wrap {
        margin: 0;
        border: 1px solid #edf2ee;
        border-radius: 18px;
        overflow: hidden;
        background: #fff;
    }
    .wallet-empty-state {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 0.6rem;
        padding: 2.5rem 1.25rem;
        text-align: center;
        font-family: Poppins;
        color: #5e7267;
    }
    .wallet-empty-state i {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        width: 58px;
        height: 58px;
        border-radius: 50%;
        background: #eef6ef;
        color: #24562b;
        font-size: 22px;
    }
    .wallet-empty-state h4 {
        margin: 0;
        font-size: 18px;
        font-weight: 700;
        color: #16372d;
    }
    .wallet-empty-state p {
        margin: 0;
        max-width: 420px;
        font-size: 13px;
        line-height: 1.7;
    }
    .inputs-field {
        font-size: 14px;
        font-family: Poppins;
        height: 45px;
    }
    
    .content-center {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        border: solid 1px #170e0fac;
        border-radius: 4px;
        padding: 0.5rem;
        margin: 4px;
    }
    
    .box1 {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        border-radius: 10px;
        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
        font-family: Poppins;
    
        a {
            text-decoration: none;
            color: #000;
        }
    }
    
    .image-input {
        margin-top: 10px;
    }
    
    .box-icon {
        padding-left: 0.4rem;
        font-size: 35px;
        color: #637807;
    }
    
    .box-details {
        font-size: 14px;
        color: #170e0fac;
    }
    
    .box1:hover {
        transform: scale(1.1);
        transition: transform 0.3s ease;
        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.3), 0 6px 20px 0 rgba(0, 0, 0, 0.24);
        cursor: pointer;
    }
    
    .box2 {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        border-radius: 10px;
        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
        font-family: Poppins;
    
        a {
            text-decoration: none;
            color: #000;
        }
    }
    
    .box2:hover {
        transform: scale(1.1);
        transition: transform 0.3s ease;
        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.3), 0 6px 20px 0 rgba(0, 0, 0, 0.24);
        cursor: pointer;
    }
    
    .box3 {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        border-radius: 10px;
        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
        font-family: Poppins;
    
        a {
            text-decoration: none;
            color: #000;
        }
    }
    
    .box3:hover {
        transform: scale(1.1);
        transition: transform 0.3s ease;
        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.3), 0 6px 20px 0 rgba(0, 0, 0, 0.24);
        cursor: pointer;
    }
    
    .box4 {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        border-radius: 10px;
        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
        font-family: Poppins;
    
        a {
            text-decoration: none;
            color: #000;
        }
    }
    
    .box4:hover {
        transform: scale(1.1);
        transition: transform 0.3s ease;
        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.3), 0 6px 20px 0 rgba(0, 0, 0, 0.24);
        cursor: pointer;
    }
    
    .box5 {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        border-radius: 10px;
        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
        font-family: Poppins;
    
        a {
            text-decoration: none;
            color: #000;
        }
    }
    
    .box5:hover {
        transform: scale(1.1);
        transition: transform 0.3s ease;
        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.3), 0 6px 20px 0 rgba(0, 0, 0, 0.24);
        cursor: pointer;
    }
    
    .box6 {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        border-radius: 10px;
        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
        font-family: Poppins;
    
        a {
            text-decoration: none;
            color: #000;
        }
    }
    
    .box6:hover {
        transform: scale(1.1);
        transition: transform 0.3s ease;
        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.3), 0 6px 20px 0 rgba(0, 0, 0, 0.24);
        cursor: pointer;
    }
    
    .img {
        border-top-right-radius: 10px;
        border-top-left-radius: 10px;
    }
    
    .box-details {
        padding: 0.4rem;
        line-height: 1.4px;
    
        .title {
            font-family: Poppins;
            font-weight: 550;
            font-size: 10px;
            text-transform: capitalize;
            color: #ff4d63;
        }
    
        .description {
            font-family: Poppins;
            font-size: 12px;
        }
    }
    
    .continue {
        display: flex;
        flex-direction: row;
        justify-content: right;
        padding-right: 0.4rem;
        font-size: 30px;
        color: rgb(237, 138, 108);
        margin-right: 10px;
        margin-top: -10px;
        margin-bottom: 10px;
    }
    
    .modal-mask {
        position: fixed;
        //z-index: 9998;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, .5);
        display: table;
        transition: opacity .4s ease;
    
        &>div {
            width: 80%;
            height: auto;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            background: #fff;
            ;
            backdrop-filter: blur(13px);
            border-radius: 10px;
            box-sizing: border-box;
            font-family: Poppins;
        }
    
        h3 {
            margin-top: 10px;
            font-size: 18px;
            color: #000;
            font-weight: bold;
            font-family: Poppins;
        }
    }
    
    .account-content {
        display: flex;
        flex-direction: column;
        justify-content: center;
        margin-right: 8px;
    }
    
    .account-content-h {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 50px;
        margin: 10px;
        padding-top: 1.3rem;
        text-transform: uppercase;
        text-align: center;
        //text-decoration: underline;
    }
    
    .add-fund {
        font-size: 12px;
        text-decoration: none !important;
        text-transform: capitalize;
    }
    
    .account-content-d {
        padding-top: 1.3rem;
        font-size: 14px;
        margin-bottom: 10px;
    }
    
    .btn-secondary {
        text-transform: uppercase;
    }
    
    .modal-close {
        color: #000;
        line-height: 50px;
        font-size: 140%;
        position: absolute;
        right: 0;
        text-align: center;
        top: 2;
        width: 70px;
        text-decoration: none;
    
        &:hover {
            color: black;
        }
    }
    
    .modal-close-mobile {
        color: #000;
        line-height: 50px;
        font-size: 140%;
        position: absolute;
        right: 0;
        text-align: center;
        top: 2;
        width: 70px;
        text-decoration: none;
    
        &:hover {
            color: black;
        }
    
        display: none;
    }

    :deep(.wallet-data-table .v-data-table__wrapper table) {
        min-width: 720px;
    }
    :deep(.wallet-data-table thead th) {
        background: #f4f8f5;
        color: #5c7065;
        font-size: 11px;
        font-weight: 700;
        letter-spacing: 0.08em;
        text-transform: uppercase;
        font-family: Poppins;
        border-bottom: 1px solid #e6eeea;
    }
    :deep(.wallet-data-table tbody td) {
        padding-top: 14px !important;
        padding-bottom: 14px !important;
        border-bottom: 1px solid #eef3ef;
        background: #fff;
    }
    :deep(.wallet-data-table tbody tr:hover td) {
        background: #f8fbf8 !important;
    }
    :deep(.wallet-data-table .v-data-footer) {
        border-top: 1px solid #eef3ef;
    }

    @media (max-width: 991px) {
        .container-fluid {
            padding: 1rem 1rem 1.5rem;
        }
        .wallet-hero {
            grid-template-columns: 1fr;
        }
        .wallet-hero-copy {
            padding: 1.4rem;
        }
        .wallet-hero-copy h1 {
            font-size: 26px;
        }
        .wallet-summary-grid {
            grid-template-columns: 1fr;
        }
        .summary-card {
            min-height: auto;
        }
        .contract-header {
            flex-direction: column;
            align-items: flex-start;
        }
    }

    @media (max-width: 767px) {
        .wallet-table-card {
            padding: 0.85rem;
            border-radius: 18px;
        }
        .contract-header {
            border-radius: 16px;
            padding: 0.95rem 1rem;
        }
        .wallet-count {
            margin-left: 0.35rem;
        }
        .a-text {
            font-size: 11px;
        }
    }
    
    a {
        text-decoration: none;
    }
    
    .shop-name {
        //font-weight: 550;
        color: #000;
        font-family: Poppins;
    }
    
    @media screen and (max-width: 768px) {
        .contract-header {
    
            font-size: 12px !important;
    
        }
    
        .counter {
            font-size: 13px;
            font-weight: 500 !important;
        }
    
        .welcome {
            font-family: Poppins;
            font-size: 16px;
            font-weight: 700;
            text-align: left;
            color: #170e0fac;
        }
    
        .content-center {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            padding: 0.9rem;
        }
    
        .image-input {
            margin-top: 20px;
        }
    
        .price-fee {
            display: flex;
            flex-direction: column;
    
            div {
                width: 100%;
            }
        }
        .margin-mobile{
            margin-top: 90px;;
        }
    
        .adjust-fee-input {
            width: 100%;
        }
    
        .account-details {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            border-radius: 4px;
            width: 100%;
        }
    
        .account-balance {
            margin-bottom: 10px;
        }
    
        .box-details {
            padding: 0.4rem;
            line-height: 1.4px;
    
            .title {
                font-family: Poppins;
                font-weight: 550;
                font-size: 8px;
                text-transform: capitalize;
                color: #ff4d63;
            }
    
            .description {
                font-family: Poppins;
                font-size: 12px;
            }
        }
    
        .inputs {
            font-size: 12px;
        }
    
        .box1 {
            width: 100%;
            height: 100%;
            border-radius: 10px;
            margin-bottom: 10px;
        }
    
        .box2 {
            width: 100%;
            height: 100%;
            border-radius: 10px;
            margin-bottom: 10px;
        }
    
        .box3 {
            width: 100%;
            height: 100%;
            border-radius: 10px;
            margin-bottom: 10px;
        }
    
        .box4 {
            width: 100%;
            height: 100%;
            border-radius: 10px;
            margin-bottom: 10px;
        }
    
        .box5 {
            width: 100%;
            height: 100%;
            border-radius: 10px;
            margin-bottom: 10px;
        }
    
        .continue {
            display: flex;
            flex-direction: row;
            justify-content: right;
            padding-right: 0.4rem;
            font-size: 30px;
            margin-top: -10px;
            color: rgb(237, 138, 108);
        }
    
        .modal-close-mobile {
            display: block;
        }
    
        .modal-close {
            display: none;
        }
    
        .account-content {
            margin: 10px;
            margin-right: 30px;
        }
    
    }
    </style>
    
